module.exports = __webpack_public_path__ + "img/logo_02.0898df6c.png";